import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1b2654e2"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "commentsContainer" }
const _hoisted_2 = { class: "scrollListContainer" }
const _hoisted_3 = {
  key: 0,
  class: "scrollListItem"
}
const _hoisted_4 = { class: "top" }
const _hoisted_5 = { class: "date" }
const _hoisted_6 = { class: "author d-flex align-items-center" }
const _hoisted_7 = ["onClick"]
const _hoisted_8 = {
  type: "button",
  class: "btn btn-round btn-sm commentDeleteButton"
}
const _hoisted_9 = { class: "bottom" }
const _hoisted_10 = ["href"]
const _hoisted_11 = { class: "addCommentContainer" }
const _hoisted_12 = { class: "btn btn-link" }
const _hoisted_13 = ["disabled"]
const _hoisted_14 = {
  key: 0,
  class: "addCommentAttachment"
}
const _hoisted_15 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_localized_text = _resolveComponent("localized-text")!
  const _component_icon_bin = _resolveComponent("icon-bin")!
  const _component_comment_text = _resolveComponent("comment-text")!
  const _component_auto_textarea = _resolveComponent("auto-textarea")!
  const _component_icon_attachment = _resolveComponent("icon-attachment")!
  const _component_file_input = _resolveComponent("file-input")!
  const _component_icon_chevronRight = _resolveComponent("icon-chevronRight")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (_ctx.comments.length == 0)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            _createVNode(_component_localized_text, {
              localizedKey: "Nessun elemento inserito",
              text: "Nessun elemento inserito"
            })
          ]))
        : (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(_ctx.comments, (item, i) => {
            return (_openBlock(), _createElementBlock("div", {
              class: "scrollListItem comment",
              key: i
            }, [
              _createElementVNode("div", _hoisted_4, [
                _createElementVNode("div", _hoisted_5, _toDisplayString(_ctx.$filters.date(item.createdOn, 'DD-MM-YYYY HH:mm')), 1),
                _createElementVNode("div", _hoisted_6, [
                  _createTextVNode(_toDisplayString(item.author.name) + " ", 1),
                  (_ctx.$store.state.isAdmin())
                    ? (_openBlock(), _createElementBlock("div", {
                        key: 0,
                        class: "deleteComment ms-1",
                        onClick: ($event: any) => (_ctx.deleteComment(item))
                      }, [
                        _createElementVNode("button", _hoisted_8, [
                          _createVNode(_component_icon_bin)
                        ])
                      ], 8, _hoisted_7))
                    : _createCommentVNode("", true)
                ])
              ]),
              _createElementVNode("div", _hoisted_9, [
                _createVNode(_component_comment_text, { comment: item }, null, 8, ["comment"]),
                (item.attachments.length > 0)
                  ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(item.attachments, (x, i) => {
                      return (_openBlock(), _createElementBlock("div", {
                        key: i,
                        class: "fs-12 mb-2"
                      }, [
                        _createElementVNode("a", {
                          class: "text-primary",
                          href: x.publicUrl,
                          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.$store.state.openBrowser && _ctx.$store.state.openBrowser(...args))),
                          target: "_blank"
                        }, _toDisplayString(x.fileName), 9, _hoisted_10)
                      ]))
                    }), 128))
                  : _createCommentVNode("", true)
              ])
            ]))
          }), 128))
    ]),
    (_ctx.modify)
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
          _createElementVNode("div", _hoisted_11, [
            _createVNode(_component_auto_textarea, {
              class: "form-control",
              placeholder: "Scrivi qui",
              modelValue: _ctx.commentText,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.commentText) = $event)),
              maxHeight: 150
            }, null, 8, ["modelValue"]),
            _createElementVNode("label", _hoisted_12, [
              _createVNode(_component_icon_attachment),
              _createVNode(_component_file_input, {
                class: "hidden",
                modelValue: _ctx.tempFile,
                "onUpdate:modelValue": [
                  _cache[2] || (_cache[2] = ($event: any) => ((_ctx.tempFile) = $event)),
                  _ctx.addFile
                ]
              }, null, 8, ["modelValue", "onUpdate:modelValue"])
            ]),
            _createElementVNode("button", {
              type: "button",
              class: "btn btn-round flex-shrink-0",
              disabled: !_ctx.canSaveComment,
              onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.addComment && _ctx.addComment(...args)))
            }, [
              _createVNode(_component_icon_chevronRight)
            ], 8, _hoisted_13)
          ]),
          (_ctx.filesToUpload.length > 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.filesToUpload, (item) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: item.name
                  }, [
                    _createVNode(_component_localized_text, {
                      localizedKey: "Allegato:",
                      text: "Allegato:"
                    }),
                    _createTextVNode(" " + _toDisplayString(item.name) + " ", 1),
                    _createElementVNode("button", {
                      type: "button",
                      class: "fs-12 btn btn-danger btn-sm",
                      onClick: ($event: any) => (_ctx.removeFile(item))
                    }, " x ", 8, _hoisted_15)
                  ]))
                }), 128))
              ]))
            : _createCommentVNode("", true)
        ], 64))
      : _createCommentVNode("", true)
  ]))
}